export const SHOPPING_CART_INDEX_LOAD = 'SHOPPING_CART_INDEX_LOAD';
